import api from "@/lib/api";

export default {
  urlGetAll: "/api/v1/human-resources/collaborator-price-table/get-all",
  urlDelete: "/api/v1/human-resources/collaborator-price-table/delete",
  urlCreate: "/api/v1/human-resources/collaborator-price-table/create",
  urlUpdate: "/api/v1/human-resources/collaborator-price-table/update",

  getAll(collaboratorId, params) {
    return api.get(this.urlGetAll, { params: { ...params, any: collaboratorId } });
  },

  save(model) {
    const isNew = !model.id;
    return isNew ? api.post(this.urlCreate, model) : api.put(this.urlUpdate, model);
  },

  delete(ids) {
    return api.delete(this.urlDelete, { data: { ids } });
  },
};
